<router-outlet></router-outlet>
<p-toast position="top-right" />

<!-- Modales globales -->
<app-forum-lead-capture-modal></app-forum-lead-capture-modal>

<!-- Suivi d'upload en arrière-plan (non bloquant, persiste sur toute la plateforme) -->
<app-bulk-upload-progress />
